import React, { useRef, useEffect, useState } from 'react';

const Tooltip = (props) => {
  const { showByCondition, header, content, children, direction } = props;

  const labelRef = useRef(null);

  const tooltipRef = useRef(null);

  const [style, setStyle] = useState({});

  useEffect(() => {
    if (labelRef.current && tooltipRef.current) {
      const leftPositionBody = (labelRef.current?.offsetWidth - tooltipRef.current?.offsetWidth) / 2;

      const topPositionBody = (labelRef.current?.offsetHeight - tooltipRef.current?.offsetHeight) / 2;

      if (direction === 'bottom' || direction === 'top') {
        setStyle({
          left: leftPositionBody + 'px',
        });
      } else {
        setStyle({
          top: topPositionBody + 'px',
        });
      }
    }
  }, [labelRef, tooltipRef, direction]);

  return (
    <div className="tooltip" ref={labelRef}>
      {children}
      {showByCondition && (
        <div ref={tooltipRef} style={style} className={`tooltip__body tooltip__body--${direction}`}>
          {header && <span className="tooltip__header">{header}</span>}
          {content && <span className="tooltip__content">{content}</span>}
        </div>
      )}
    </div>
  );
};

export default Tooltip;

Tooltip.defaultProps = {
  showByCondition: true,
};
